<template>
  <form>
    <div class="table-responsive">
      <table class="table table-striped" style="margin-top: 1rem;">
        <thead>
          <tr>
            <th scope="col">Printers</th>
            <th scope="col">Avg.</th>
            <th scope="col" class="nowrap" v-for="month in months">
              {{ month.formattedMonth }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="trial.hasSmallPrinters">
            <th scope="row">4'</th>
            <th scope="row">{{ avgSmallPrinters }}</th>
            <td v-for="burnRate in trial.small_printer_burn_rates">
              <burn-rate-input
                :type="type"
                :burn-rate="burnRate"
                @burnRateUpdated="updateBurnRate"
              />
            </td>
          </tr>
          <tr v-if="trial.hasLargePrinters">
            <th scope="row">8'</th>
            <th scope="row">{{ avgLargePrinters }}</th>
            <td v-for="burnRate in trial.large_printer_burn_rates">
              <burn-rate-input
                :type="type"
                :burn-rate="burnRate"
                @burnRateUpdated="updateBurnRate"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</template>

<script>
  import avgBurnRateMixin from './../avg-burnrate-mixin'

  export default {
    mixins: [avgBurnRateMixin],
    props: ['initTrial', 'type'],
    data() {
      return {
        trial: this.initTrial,
      }
    },
    methods: {
      updateBurnRate(payload) {
        const burnatesToSearch = payload.burnRate.printer === 'small' ?
          this.trial.small_printer_burn_rates : this.trial.large_printer_burn_rates
        const burnRateIndex = burnatesToSearch.findIndex(existingBurnrate => existingBurnrate.id === payload.burnRate.id)
        burnatesToSearch[burnRateIndex].rate = payload.rate
      },
    },
    computed: {
      months() {
        if (this.trial.hasSmallPrinters) {
          return this.trial.small_printer_burn_rates
        }
        if (this.trial.hasLargePrinters) {
          return this.trial.large_printer_burn_rates
        }
        return []
      },
      getModel() {
        return this.trial
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/trials/burn_rates/BurnRateTable.vue